import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../Services/login-instance";
const LogoutScreen = ({ ...props }) => {
  logOut();
  return <></>;
};
export default LogoutScreen;
